import {FormControl, FormField, TextInput} from 'platform/components';
import {Grid, GridItem} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {getPriceWithVat, getPriceWithoutVat, useTenant} from '@dms/shared';

import {PriceListItem} from '../types/PriceListItem';

interface RateFormRowProps {
  control: FormControl<PriceListItem>;
  formApi: UseFormReturn<PriceListItem>;
  name: 'rate' | 'ratePerKilometer';
  label: string;
  vatRate: {
    label: string;
    value: number;
  };
}

export function RateFormRow(props: RateFormRowProps) {
  const {tenantCurrency} = useTenant();

  const handleUpdatePriceWithVat = (priceWithoutVat: number | null) => {
    if (isNil(priceWithoutVat)) {
      props.formApi.setValue(`${props.name}.withVat`, 0);
      return;
    }

    const priceWithVat = getPriceWithVat(priceWithoutVat.toString(), props.vatRate.value);
    props.formApi.setValue(`${props.name}.withVat`, priceWithVat);
  };

  const handleUpdatePriceWithoutVat = (priceWithVat: number | null) => {
    if (isNil(priceWithVat)) {
      props.formApi.setValue(`${props.name}.withoutVat`, 0);
      return;
    }

    const priceWithoutVat = getPriceWithoutVat(priceWithVat.toString(), props.vatRate.value);
    props.formApi.setValue(`${props.name}.withoutVat`, priceWithoutVat);
  };

  return (
    <Grid columns={12}>
      <GridItem span={6}>
        <FormField
          control={props.control}
          name={`${props.name}.withoutVat`}
          type="currency"
          label={`${props.label} (${i18n.t('general.labels.withoutVat')})`}
          currency={tenantCurrency}
          isRequired
          decimalPlaces={2}
          onChange={handleUpdatePriceWithVat}
        />
      </GridItem>

      <GridItem span={2}>
        <TextInput
          value={props.vatRate.label}
          isDisabled
          label={i18n.t('general.labels.vatRate')}
          tooltip={i18n.t('entity.rental.labels.vatRateTooltip')}
        />
      </GridItem>

      <GridItem span={4}>
        <FormField
          control={props.control}
          name={`${props.name}.withVat`}
          type="currency"
          label={`${props.label} (${i18n.t('general.labels.withVat')})`}
          currency={tenantCurrency}
          isRequired
          decimalPlaces={2}
          onChange={handleUpdatePriceWithoutVat}
        />
      </GridItem>
    </Grid>
  );
}
